import React from 'react';
import PropTypes from 'prop-types';

import DataTableToolbar from '../../_Shared/DataTables/DataToolbar';
import DataTable from '../../_Shared/DataTables/DataTable';
import AppContent from '../../_Shared/Layout/AppContent';

import Tooltip from '@material-ui/core/Tooltip';
import IconButton from '@material-ui/core/IconButton';
import LinearProgress from '@material-ui/core/LinearProgress';
import Grid from '@material-ui/core/Grid';
import Divider from '@material-ui/core/Divider';
import MenuItem from '@material-ui/core/MenuItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';

import AddCircleIcon from '@material-ui/icons/AddCircle';
import DeleteForeverIcon from '@material-ui/icons/DeleteForever';
import EditIcon from '@material-ui/icons/Edit';

import CreateModal from '../../_Shared/CreateModal';
import Select from '../../_Shared/SearchableDropdown';

const _ = require('lodash');

class ACLList extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            name: '',
            showModal: false,
            anchorEl: null
        }
    }

    componentDidMount() {
        this.props.onActivate();
    }

    componentDidUpdate(prevProps, prevState) {
        const { advertiser } = this.props;
        if (advertiser !== null && !_.isEqual(prevProps.advertiser, advertiser)) {
            this.setState({ advertiser });
        }
    }

    toggleRowMenu = currentTarget => {
        this.setState((prevState) => {
            return { anchorEl: prevState.anchorEl === currentTarget ? null : currentTarget }
        })
    }

    closeToggleRowMenu = () => {
        this.setState({ anchorEl: null });
    }

    toggleCreateModal = e => {
        const { showModal } = this.state;
        this.setState({ showModal: !showModal, name: '', isUpdate: false });
    }

    toggleEditModal = e => {
        const { name, showModal } = this.state;
        this.setState({ showModal: !showModal, name: name, isUpdate: true });
    }

    handleInputChange = name => this.setState({ name })

    selectElement = (user, index) => {
        this.setState({ name: user.value, selectedIndex: index });
    }

    createOrUpdateACL = e => {
        const { advertiser, onAdvertiserUpdated } = this.props;
        const { name, isUpdate, selectedIndex } = this.state;
        if (!isUpdate) {
            onAdvertiserUpdated(Object.assign({}, advertiser, { acl: [...advertiser.acl, name] }), 'add_acl');
        } else {
            let aux = Object.assign([], advertiser.acl);
            aux.splice(selectedIndex, 1, name);
            onAdvertiserUpdated(Object.assign({}, advertiser, { acl: aux }), 'update_acl');
        }
        this.toggleCreateModal(e);
        this.setState({ name: '', anchorEl: null });
    }

    deleteACL = () => {
        const { advertiser, onAdvertiserUpdated } = this.props;
        const { name } = this.state;
        onAdvertiserUpdated(Object.assign({}, advertiser, { acl: advertiser.acl.filter(x => x !== name) }), 'delete_acl');
        this.setState({ name: '', anchorEl: null });
    }

    render() {
        const { advertiser, users, loading } = this.props;
        const { showModal, name, anchorEl } = this.state;

        return (<AppContent>
            {
                loading && <LinearProgress variant="query" />
            }
            <DataTableToolbar title="Access Control List" numSelected={0} >
                <Tooltip title="Add New">
                    <IconButton onClick={this.toggleCreateModal} color="secondary"><AddCircleIcon /></IconButton>
                </Tooltip>
            </DataTableToolbar>
            {
                advertiser && advertiser.accessControlList &&
                <DataTable columns={[{ label: 'Name', field: 'name' }]} anchorEl={anchorEl} rows={advertiser.accessControlList.map(x => ({ name: x.userName, value: x.id }))}
                    toggleRowMenu={this.toggleRowMenu} onElementSelect={this.selectElement} onCloseToggleRowMenu={this.closeToggleRowMenu}>
                    <MenuItem onClick={this.toggleEditModal}>
                        <ListItemIcon><EditIcon /></ListItemIcon>
                        <ListItemText inset primary="Settings" />
                    </MenuItem>
                    <Divider />
                    <MenuItem onClick={this.deleteACL}>
                        <ListItemIcon><DeleteForeverIcon /></ListItemIcon>
                        <ListItemText inset primary="Delete" />
                    </MenuItem>
                </DataTable>
            }
            <CreateModal title="Create/Edit ACL" open={showModal} closeHandler={this.toggleCreateModal} saveHandler={this.createOrUpdateACL}>
                <Grid container item spacing={24}>
                    <Grid item xs>
                        {
                            users &&
                            <Select options={[].concat(users).map(x => { return { 'label': x.emailAddress, 'value': x.id } })} value={name}
                                name="name" label="User" onChange={value => this.handleInputChange(value)} placeholder="Please select a User" />
                        }
                    </Grid>
                </Grid>
            </CreateModal>
        </AppContent>)
    }
}

ACLList.propTypes = {
    advertiser: PropTypes.object.isRequired,
};


export default ACLList;


// WEBPACK FOOTER //
// ./src/Components/Presentation/Advertisers/ACLs/ACLList.js